/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createSubscriber,
	createContainer,
	type BoundActions,
	type OverrideContainerComponent,
	type SubscriberComponent,
} from '@atlassian/react-sweet-state';
import Store from './store.tsx';
import type { State, Actions } from './types.tsx';

export const NavigationUISubscriber: SubscriberComponent<
	State,
	BoundActions<State, Actions>,
	unknown
> = createSubscriber(Store, {
	displayName: 'NavigationUISubscriber',
	selector: null,
});

export const NavigationUIContainer: OverrideContainerComponent<unknown> = createContainer(Store);

export type NavigationUISubscriberType = typeof NavigationUISubscriber;
